export enum InvitationStatus{
    Accepted="Accepted",
    Declined = "Declined",
    Expired = "Expired",
    Sent = "Sent",
    Cancelled = "Cancelled"
}
